<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<crumbs :txt="a" type="2" :ljList="ljList" @hdBtn="hdBtn" :crumFlag="crumFlag" height="53px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="hdBtn">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="timBox">
				<div class="timBoxTit">
					<div class="timBoxTitInfo">
						<div class="gkztBox supHove3" v-if="types == 'zt' || collegeExaminationId" @click="xzBtn">
							<i class="el-icon-download"></i>
							下载试卷
						</div>
						<div class="timBoxTitInfoImg">
							<el-image :src="$imgFn('试卷', 2)" lazy></el-image>
						</div>
						<div class="timBoxTitInfoCont">
							<div class="timBoxTitInfoTit">
								<h2>{{ tmData.title }}</h2>
								<div class="shouc supHove3" @click="scFn(tmData)" v-if="types != 'zt'" :class="tmData.isCollect ? 'activeBtn' : ''">
									<img src="@/assets/img/sc (4).svg" v-if="!tmData.isCollect" alt="" />
									<img src="@/assets/img/sc (2).svg" v-if="tmData.isCollect" alt="" />
									<span>{{ tmData.isCollect ? '已收藏' : '收藏' }}</span>
								</div>
							</div>
							<div class="zzAdminItemJj" v-if="types != 'zt'">
								<div
									class="zzAdminItemJjI"
									:class="`zzAdminItemJjI${(index + 1) % 6}`"
									v-for="(i, index) in tmData.provincesClassificationName?.split(',')"
									:key="index"
								>
									{{ i }}
								</div>
							</div>
							<p class="timBoxTitInfoP" v-if="types == 'zt'">试卷编号：{{ tmData.number }}</p>
							<p class="timBoxTitInfoP" v-if="types == 'zt'">本卷听力题型结构：{{ tmData.questionTypeStructure }}</p>
							<div class="timBoxTitInfoSts" :style="{ marginTop: types == 'zt' ? '0px' : '10px' }">
								<div class="timBoxTitInfoSt">
									<img src="@/assets/img/shit.svg" alt="" />
									<span>试题数量：{{ tmData.questionNum }}题</span>
								</div>
								<div class="timBoxTitInfoSt">
									<img src="@/assets/img/dati.svg" alt="" />
									<span>答题时间：{{ Math.floor(tmData.answerTime / 60) }}分钟</span>
								</div>
								<div class="timBoxTitInfoSt">
									<img src="@/assets/img/stzf.svg" alt="" />
									<span>试题总分：{{ tmData.score }}分</span>
								</div>
							</div>
							<div class="timBoxTitInfoFot" v-if="types != 'zt'">
								<div class="timBoxTitInfoFotItem">
									<img src="@/assets/img/zfl.svg" v-if="tmData.listenEveryDayId" alt="" />
									<span v-if="tmData.listenEveryDayId">转发量：{{ tmData.forwarding || 0 }}</span>
									<img src="@/assets/img/xiazai.svg" v-if="tmData.collegeExaminationId" alt="" />
									<span v-if="tmData.collegeExaminationId">下载量：{{ tmData.download || 0 }}</span>
								</div>
								<div class="timBoxTitInfoFotItem">
									<span>有效日期：{{ (tmData.endTime || tmData.createTime) | momentYR('YYYY年MM月DD日') }}</span>
								</div>
								<!-- <div class="timBoxTitInfoFotItem">
					<span>编写人：{{ tmData.createNickName }}</span>
				  </div> -->
							</div>
						</div>
						<div class="timBoxTitInfoRig">
							<div class="timBoxTitInfoBtn timBoxTitInfoBtn1 supHove3" @click="fullBtn">
								<img src="@/assets/img/qp.svg" alt="" />
								<span>全屏解析</span>
							</div>
							<div class="timBoxTitInfoBtn supHove3" @click="kaoBtn('正在考试中')">
								<img src="@/assets/img/ks.svg" alt="" />
								<span>模拟考试</span>
							</div>
						</div>
					</div>
					<div class="timBoxEw">
						<div class="timBoxEwL" v-if="!groupExamId">
							<div class="timBoxIcon">
								<img src="@/assets/img/smfx.svg" alt="" />
								<span>分享本套</span>
							</div>
							<p>扫码打开本套试卷</p>
						</div>
						<div class="timBoxEwR" v-if="!groupExamId">
							<img :src="qrCodeImage" v-if="qrCodeImage" alt="" />
						</div>
					</div>
				</div>
	
				<div class="timCont">
					<div class="timContL" ref="timContL">
						<div class="timContLT">
							<p>
								套题难易度：{{ tmData.difficultyScore }}
								<span>系数越小越困难，系数越大越简单（0 < 套题难易度 < 1）</span>
							</p>
							<div class="timContLTTj">
								<h2>考点统计</h2>
								<p v-if="tmData.testCenterNames">
									<span v-for="(item, index) in tmData.testCenterNames.split(',')">
										{{ item }}{{ tmData.testCenterNames.split(',').length - 1 == index ? ' ' : '、' }}
									</span>
								</p>
							</div>
							<div class="timContLTTj">
								<h2>题型统计</h2>
								<p :title="tmData.questionTypeStatistics">{{ tmData.shorthandStatistics }}</p>
<!-- 								<p>{{ tmData.questionTypeStatistics }}</p> -->
							</div>
							<div
								class="ausBox"
								v-loading="loading"
								element-loading-text="拼命加载中"
								element-loading-spinner="el-icon-loading"
								element-loading-background="rgba(0, 0, 0, 0.8)"
							>
								<myAudio
									types="2"
									v-if="audioFlag"
									:audioUrl="
										tmData.questionAudioFilePath?.includes('blob:')
											? tmData.questionAudioFilePath
											: tmData.questionAudioFilePath
											? $imgUrl + tmData.questionAudioFilePath
											: ''
									"
									:title="tmData.questionAudioFileName"
								/>
							</div>
						</div>
						<div class="timContLB" v-if="types != 'zt'">
							<h1>试题展示</h1>
							<div v-if="tmData.yydExamination?.yydExaminationQuestionList.length">
								<div class="timContLBTm" v-for="(item, index) in tmData.yydExamination?.yydExaminationQuestionList" :key="index">
									<div class="timContLBTmT" v-html="item.originalContent"></div>
									<div v-for="(i, s) in item.yydSmallQuestionList" :key="s">
										<div class="timContLBTmW">{{ i.num }}.{{ i.title }}</div>
										<div class="timContLBTmD">
											<p v-for="(iChild, sChild) in i.yydSmallQuestionOptionList" :key="sChild">{{ ywArr[sChild] }}.{{ iChild.content }}</p>
										</div>
									</div>
								</div>
							</div>
							<div v-if="!tmData.yydExamination?.yydExaminationQuestionList.length">
								<el-empty description="暂无试题"></el-empty>
							</div>
						</div>
						<div class="timContLB" v-if="types == 'zt'">
							<h1>试题展示</h1>
							<div v-if="tmData.yydGroupExamQuestionBodyDtoList?.length">
								<div class="timContLBTm" v-for="(item, index) in tmData.yydGroupExamQuestionBodyDtoList" :key="index">
									<div class="timContLBTmT" v-html="item.originalContent"></div>
									<div v-for="(i, s) in item.yydSmallQuestionList" :key="s">
										<div class="timContLBTmW">{{ i.num }}.{{ i.title }}</div>
										<div class="timContLBTmD">
											<p v-for="(iChild, sChild) in i.yydSmallQuestionOptionList" :key="sChild">{{ ywArr[sChild] }}.{{ iChild.content }}</p>
										</div>
									</div>
								</div>
							</div>
							<div v-if="!tmData?.yydGroupExamQuestionBodyDtoList?.length">
								<el-empty description="暂无试题"></el-empty>
							</div>
						</div>
					</div>
					<div class="timContR" :style="{ marginTop: groupExamId ? '-146px' : '0px' }">
						<div class="meiWecTit meiWecTit5">
							<img src="@/assets/img/rmen.svg" alt="" />
							<span>更多推荐</span>
						</div>
						<div class="meiWecRBoxC" v-if="!tjData.length">
							<el-empty description="暂无推荐"></el-empty>
						</div>
						<div class="meiWecRBoxC" v-if="tjData.length">
							<div class="meiWecRCItem supHove5" v-for="(item, index) in tjData" :key="index" @click="tjBtn(item)">
								<div class="imgs">
									<el-image :src="$imgFn('试卷', 2)" lazy></el-image>
								</div>
								<div class="meiWecRCItemR">
									<p :title="item.title">{{ item.title }}</p>
									<div class="meiWecRCItemRF">
										<div class="meiWecFjVip" v-if="types != 'zt'">
											<img src="@/assets/img/st.svg" alt="" />
											<span>试题数量：{{ item.questionNum }}套</span>
										</div>
										<div class="meiWecFjXz" v-if="types != 'zt'">
											<img src="@/assets/img/zfl.svg" v-if="tmData.listenEveryDayId" alt="" />
											<span v-if="tmData.listenEveryDayId">转发量：{{ item.forwarding || 0 }}</span>
											<img src="@/assets/img/xiazai.svg" v-if="tmData.collegeExaminationId" alt="" />
											<span v-if="tmData.collegeExaminationId">下载量：{{ item.download || 0 }}</span>
										</div>
										<div class="meiWecFjXz" v-if="types == 'zt'">题型结构：{{ item.number }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<fullScreen :tmDec="tmDec" v-if="fullFlag" @gbFn="fullFlag = false" ref="fullBoxs" />
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import crumbs from '@/components/hearder/crumbs';
import userHeader from '@/components/hearder/userHeader';
import myAudio from '@/components/pubComponents/myAudio';
import fullScreen from '@/page/user/fullScreen.vue';
import axios from 'axios';
// 导入streamsaver
import { batchDownload } from '@/assets/js/xz';

export default {
	name: 'timDec',
	data() {
		return {
			type: 1, // 1文章 2视频 3音乐 4电影
			txt: '',
			tmData: {},
			ywArr: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
			types: '', // zt从高考真题跳进
			fullFlag: false,
			collegeExaminationId: '',
			groupExamId: '',
			fullscreenLoading: false,
			loading: false,
			listenEveryDayId: '',
			a: ['个人中心'],
			tjData: [],
			qrCodeImage: '',
			audioFlag: true,
			num: 0,
			tmDec: '',
			fullscreen: '',
			crumFlag: false,
			ljList: []
		};
	},
	components: {
		userHeader,
		fullScreen,
		crumbs,
		foot,
		myAudio
	},
	methods: {
		hdBtn() {
			let item = '';
			this.ljList.pop();
			item = this.ljList[this.ljList.length - 1];
			if (!item) {
				console.log(item,111);
				this.$router.back();
				return;
			}
			if (this.collegeExaminationId) {
				this.collegeExaminationId = item.collegeExaminationId;
			}
			if (this.listenEveryDayId) {
				this.listenEveryDayId = item.listenEveryDayId;
			}
			if (this.groupExamId) {
				this.groupExamId = item.groupExamId;
			}
			this.init();
		},
		xzBtn() {
			let id = '';
			let type = '';
			if (this.collegeExaminationId) {
				id = this.collegeExaminationId;
				type = 4;
			}
			if (this.groupExamId) {
				id = this.groupExamId;
				type = 5;
			}
			let files = [];
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: this.tmData.questionBookFileId,
						id,
						type,
						downloadFlag: true,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						let FileName = res.fileName;
						this.$http
							.get('api/app/common/getUrl', {
								params: {
									fileId: this.tmData.questionAudioFileId,
									id,
									type,
									downloadFlag: true,
									clientType: 1
								}
							})
							.then((red) => {
								this.fullscreenLoading = false;
								if (red.code == 200) {
									let FileName1 = red.fileName;
									batchDownload(this.a[this.a.length - 1], [
										{
											name: FileName,
											url: res.msg
										},
										{
											name: FileName1,
											url: red.msg
										}
									]);
								}
							});
					}
				});
		},
		scFn(item) {
			let type = '';
			let assetsId = '';
			if (this.collegeExaminationId) {
				type = 7;
				assetsId = item.collegeExaminationId;
			}
			if (this.listenEveryDayId) {
				type = 6;
				assetsId = item.listenEveryDayId;
			}
			this.$scFn(
				{
					type,
					assetsId
				},
				item.isCollect,
				this.init
			);
		},
		ewmaFn() {
			let url = '';
			if (this.listenEveryDayId) {
				// 每日一听
				url = `pages/home/d_class/exam/exam-question-detail?examId=${this.listenEveryDayId}&type=2&isShare=true`;
			}
			if (this.collegeExaminationId) {
				// 高考真题
				url = `pages/home/d_class/exam/exam-question-detail?examId=${this.collegeExaminationId}&type=3&isShare=true`;
			}
			console.log(url, 8889999);
			this.$http
				.get('api/app/common/getMiniProgramsCodes', {
					params: {
						url,
						clientType: '1'
					},
					responseType: 'blob'
				})
				.then((res) => {
					if (res) {
						const blob = new Blob([res], { type: 'image/png' });
						this.qrCodeImage = URL.createObjectURL(blob);
					}
				});
		},

		btnFn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './scDec',
				query: {
					type: 1,
					txt: str
				}
			});
		},
		fullBtn() {
			if (this.groupExamId) {
				// this.$router.push({
				//   path: './fullScreen',
				//   query: {
				//     tmDec: JSON.stringify({
				//       name: this.a[this.a.length-1],
				//       tabTxt: this.a[this.a.length-1],
				//       yydTextbookQuestions: this.tmData.yydGroupExamQuestionBodyDtoList
				//     }),
				//   }
				// })
				this.tmDec = JSON.stringify({
					name: this.a[this.a.length - 1],
					tabTxt: this.a,
					yydTextbookQuestions: this.tmData.yydGroupExamQuestionBodyDtoList
				});
				this.fullFlag = true;
				this.$nextTick(() => {
					this.$refs['fullBoxs'].onFullScreen();
				});
				return;
			}
			this.tmDec = JSON.stringify({
				name: this.a[this.a.length - 1],
				tabTxt: this.a,
				yydTextbookQuestions: this.tmData.yydExamination.yydExaminationQuestionList
			});
			this.fullFlag = true;
			this.$nextTick(() => {
				this.$refs['fullBoxs'].onFullScreen();
			});
			// this.$router.push({
			//   path: './fullScreen',
			//   query: {
			//     tmDec: JSON.stringify({
			//       name: this.a[this.a.length-1],
			//       tabTxt: this.a[this.a.length-1],
			//       yydTextbookQuestions: this.tmData.yydExamination.yydExaminationQuestionList
			//     }),
			//   }
			// })
		},
		kaoBtn(txt) {
			let str = this.a[1] + '~' + txt;
			this.$router.push({
				path: './kaoshi',
				query: {
					txt: str,
					tabFtxt: this.a[0],
					templateId: this.groupExamId ? this.tmData.templateId : this.tmData.yydExamination.templateId,
					collegeExaminationId: this.collegeExaminationId,
					listenEveryDayId: this.listenEveryDayId,
					groupExamId: this.groupExamId
				}
			});
		},
		tlBtn() {
			if (this.tmData.questionAudioFileId) {
				this.$http
					.get('api/app/common/getUrl', {
						params: {
							fileId: this.tmData.questionAudioFileId,
							clientType: 1
						}
					})
					.then((res) => {
						this.$set(this.tmData, 'questionAudioFileName', res.fileName);
						axios({
							method: 'get',
							url: res.msg,
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						})
							.then((red) => {
								this.loading = false;
								if (red && red.data) {
									const blob = new Blob([red.data], { type: 'audio/mpeg' });
									this.$set(this.tmData, 'questionAudioFilePath', URL.createObjectURL(blob));
									this.audioFlag = true;
								}
							})
							.catch((err) => {
								console.log(err);
							});
					});
			}
		},
		init() {
			this.fullscreenLoading = true;
			if (this.collegeExaminationId) {
				this.$http.get(`api/app/yydCollegeExamination/${this.collegeExaminationId}`).then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						let num = 1;
						res.data.yydExamination.yydExaminationQuestionList.forEach((item) => {
							item.yydSmallQuestionList.forEach((i) => {
								i.num = num;
								num++;
							});
						});
						this.tmData = res.data;
						this.audioFlag = false;
						this.loading = true;
						this.tlBtn();
					}
				});
				setTimeout(() => {
					let num = this.$refs['timContL'].offsetHeight - 64;
					console.log(num, 8889);
					let nlnum = 93;
					let nums = Math.floor(num / nlnum);
					this.$http
						.get(`api/app/yydCollegeExamination/recommend/${this.collegeExaminationId}`, {
							params: {
								pageNum: 1,
								pageSize: nums < 3 ? 3 : nums
							}
						})
						.then((res) => {
							if (res.code == 200) {
								this.tjData = res.rows || [];
							}
						});
				}, 900);
			}
			if (this.listenEveryDayId) {
				// 每日一听
				this.$http.get(`api/app/yydListenEveryDay/${this.listenEveryDayId}`).then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						let num = 1;
						res.data.yydExamination.yydExaminationQuestionList.forEach((item) => {
							item.yydSmallQuestionList.forEach((i) => {
								i.num = num;
								num++;
							});
						});
						this.tmData = res.data;
						this.loading = true;
						this.audioFlag = false;
						this.tlBtn();
					}
				});
				// 每日一听推荐
				setTimeout(() => {
					let num = this.$refs['timContL'].offsetHeight - 64;
					console.log(num, 8889);
					let nlnum = 93;
					let nums = Math.floor(num / nlnum);
					this.$http
						.get(`api/app/yydListenEveryDay/recommend/${this.listenEveryDayId}`, {
							params: {
								pageNum: 1,
								pageSize: nums < 3 ? 3 : nums
							}
						})
						.then((res) => {
							if (res.code == 200) {
								this.tjData = res.rows || [];
							}
						});
				}, 900);
			}
			if (this.groupExamId) {
				// 我的组卷
				this.$http
					.post(`api/app/yydGroupQuestionExam/pagerInfo`, {
						id: this.groupExamId
					})
					.then((res) => {
						this.fullscreenLoading = false;
						if (res.code == 200) {
							let num = 1;
							res.data.yydGroupExamQuestionBodyDtoList.forEach((item) => {
								item.yydSmallQuestionList.forEach((i) => {
									i.num = num;
									num++;
								});
							});
							this.tmData = res.data;
							this.loading = true;
							this.audioFlag = false;
							this.tlBtn();
						}
					});
				// 我的组卷推荐
				setTimeout(() => {
					let num = this.$refs['timContL'].offsetHeight - 64;
					console.log(num, 8889);
					let nlnum = 93;
					let nums = Math.floor(num / nlnum);
					this.$http
						.get(`api/app/yydGroupQuestionExam/recommend/${this.groupExamId}`, {
							params: {
								pageNum: 1,
								pageSize: nums < 3 ? 3 : nums
							}
						})
						.then((res) => {
							if (res.code == 200) {
								this.tjData = res.rows || [];
							}
						});
				}, 900);
			}
		},
		tjBtn(item) {
			this.ljList.push(item);
			if (this.collegeExaminationId) {
				this.collegeExaminationId = item.collegeExaminationId;
			}
			if (this.listenEveryDayId) {
				this.listenEveryDayId = item.listenEveryDayId;
			}
			if (this.groupExamId) {
				this.groupExamId = item.groupExamId;
			}
			this.a.splice(this.a.length - 1, 1, item.title);
			this.init();
		}
	},
	mounted() {
		const { type, types, txt, tabFtxt, collegeExaminationId, listenEveryDayId, groupExamId, crumFlag } = this.$route.query;
		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		this.types = types || '';
		this.collegeExaminationId = collegeExaminationId || '';
		this.listenEveryDayId = listenEveryDayId || '';
		this.groupExamId = groupExamId || '';
		this.type = type || 1;
		this.txt = txt || '';
		this.a.push(txt);
		if (this.collegeExaminationId) {
			this.ljList.push({
				title: txt,
				collegeExaminationId
			});
		}
		if (this.listenEveryDayId) {
			this.ljList.push({
				title: txt,
				listenEveryDayId
			});
		}
		if (this.groupExamId) {
			this.ljList.push({
				title: txt,
				groupExamId
			});
		}
		this.ewmaFn();
		this.init();
		if (crumFlag) {
			this.crumFlag = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.timBox {
	width: 1200px;
	margin: 0 auto 10px;
	.timCont {
		display: flex;
		margin-top: 10px;
		.timContL {
			flex: 1;
			margin-right: 10px;
			.timContLB {
				background: #ffffff;
				border-radius: 6px;
				padding: 10px 17px 42px;
				h1 {
					height: 44px;
					line-height: 44px;
					color: #000000;
					font-size: 16px;
					font-weight: bold;
					padding-left: 2px;
				}
				.timContLBTm {
					margin-bottom: 10px;
					font-size: 12px;
					padding-bottom: 10px;
					border-bottom: 1px dashed #e5e5e5;
					&:last-of-type {
						margin-bottom: 0;
					}
					.timContLBTmT {
						color: #9c9c9c;
						line-height: 2;
						margin-bottom: 12px;
					}
					.timContLBTmW {
						color: #000000;
						font-weight: bold;
						margin-bottom: 9px;
					}
					.timContLBTmD {
						line-height: 2;
						font-size: 12px;
						color: #000;
					}
				}
			}
			.timContLT {
				background: #ffffff;
				border-radius: 6px;
				margin-bottom: 10px;
				padding: 16px 19px 20px 17px;
				> p {
					display: flex;
					align-items: center;
					color: #000000;
					font-size: 12px;
					font-weight: bold;
					margin-bottom: 16px;
					span {
						margin-left: 12px;
						color: #8f9190;
						font-weight: 400;
					}
				}
			}
			.timContLTTj {
				font-size: 12px;
				color: #000;
				margin-bottom: 16px;
				h2 {
					font-weight: bold;
					margin-bottom: 6px;
				}
				p {
					font-weight: 400;
					span {
					}
				}
			}
		}
	}
	.timBoxTit {
		display: flex;
		.timBoxTitInfo {
			flex: 1;
			margin-right: 10px;
			height: 166px;
			background: #ffffff;
			border-radius: 6px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			padding: 17px 17px 19px;
			position: relative;
			.gkztBox {
				background: #1d7b3a;
				color: #fff;
				width: 90px;
				height: 30px;
				position: absolute;
				top: 16px;
				right: 21px;
				font-size: 14px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 6px;
				cursor: pointer;
				i {
					margin-right: 2px;
					margin-top: 2px;
				}
			}
			.timBoxTitInfoImg {
				width: 110px;
				height: 110px;
				margin-right: 11px;
				img {
					width: 100px;
					height: 100px;
					border-radius: 6px;
				}
			}
			.timBoxTitInfoCont {
				padding-right: 200px;
				flex: 1;
				.timBoxTitInfoFot {
					display: flex;
					align-items: center;
					font-size: 12px;
					color: #8f9190;
					.timBoxTitInfoFotItem {
						margin-right: 26px;
						display: flex;
						align-items: center;
						img {
							width: 12px;
							height: 12px;
							margin-right: 7px;
						}
					}
				}
				.timBoxTitInfoP {
					font-size: 12px;
					color: #333333;
					margin: 5px 0;
				}
				.timBoxTitInfoSts {
					margin-top: 10px;
					align-items: center;
					font-size: 12px;
					color: #333333;
					margin-bottom: 7px;
					display: flex;

					.timBoxTitInfoSt {
						margin-right: 21px;
						display: flex;
						align-items: center;
					}
					img {
						width: 13px;
						height: 13px;
						margin-right: 4px;
					}
				}
				.timBoxTitInfoTit {
					display: flex;
					align-items: center;
					margin-bottom: 7px;
					h2 {
						color: #000000;
						font-size: 18px;
						font-weight: bold;
						margin-right: 16px;
					}
					.shouc {
						display: flex;
						justify-content: center;
						align-items: center;
						color: #8f9190;
						font-size: 14px;
						cursor: pointer;
						img {
							width: 15px;
							height: 15px;
							margin-right: 4px;
							margin-top: 2px;
						}
					}
					.activeBtn {
						color: #1d7b3a;
					}
				}
			}
			.timBoxTitInfoRig {
				position: absolute;
				right: 21px;
				display: flex;
				bottom: 15px;
				.timBoxTitInfoBtn {
					width: 90px;
					height: 30px;
					background: #1d7b3a;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-left: 10px;
					font-size: 14px;
					color: #ffffff;
					border-radius: 6px;
					cursor: pointer;
					img {
						width: 17px;
						height: 17px;
						margin-right: 3px;
					}
				}
				.timBoxTitInfoBtn1 {
					background: #ffac3e;
				}
			}
		}
		.timBoxEw {
			width: 310px;
			height: 166px;
			background: #ffffff;
			border-radius: 6px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.timBoxEwL {
				margin-left: 20px;
				.timBoxIcon {
					display: flex;
					font-size: 18px;
					color: #000000;
					font-weight: bold;
					align-items: center;
					margin-bottom: 6px;

					img {
						width: 18px;
						height: 18px;
						margin-right: 8px;
						margin-top: 2px;
					}
				}
				p {
					font-size: 12px;
					color: #adadad;
				}
			}
			.timBoxEwR {
				width: 150;
				height: 150px;
				margin-right: 25px;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
	}
}
.timContR {
	background: #fff;
	padding: 0 13px 15px;
	border-radius: 6px;
	width: 310px;
	box-sizing: border-box;
	.meiWecTit {
		height: 63px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #f8f8f8;
		font-size: 18px;
		font-weight: bold;
		img {
			width: 30px;
			height: 30px;
			margin-right: 7px;
		}
	}
	.meiWecRBoxC {
		margin-top: 5px;
		.meiWecRCItem {
			padding: 16px 3px;
			border-bottom: 1px solid #f8f8f8;
			display: flex;
			align-items: center;
			cursor: pointer;
			.imgs {
				width: 60px;
				height: 60px;
				margin-right: 7px;
				border-radius: 6px;
			}
			.meiWecRCItemR {
				flex: 1;
				p {
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
					font-size: 14px;
					width: 205px;
					color: #000000;
					font-weight: bold;
					margin-bottom: 10px;
				}
				.meiWecRCItemRF {
					display: flex;
					justify-content: space-between;
					> div {
						display: flex;
						align-items: center;
						font-size: 12px;
						img {
							margin-right: 5px;
						}
					}
					.meiWecFjVip {
						color: #8f9190;
						img {
							width: 15px;
							height: 13px;
						}
					}
					.meiWecFjXz {
						color: #8f9190;
						img {
							width: 12px;
							height: 13px;
						}
					}
				}
			}
			&:last-of-type {
				border-bottom: none;
			}
		}
	}
}
.zzAdminItemJj {
	display: flex;
	align-items: center;
	.zzAdminItemJjI {
		padding: 0 10px;

		height: 20px;
		font-size: 12px;
		text-align: center;
		line-height: 20px;
		border-radius: 4px;
		margin-right: 10px;
	}
	.zzAdminItemJjI0 {
		background: #fef7f0;
		color: #f7860f;
	}
	.zzAdminItemJjI1 {
		background: #fef7f0;
		color: #f7860f;
	}
	.zzAdminItemJjI2 {
		background: #f6fcf1;
		color: #5ec009;
	}
	.zzAdminItemJjI3 {
		background: #f1f7fe;
		color: #1675e5;
	}
	.zzAdminItemJjI4 {
		background: #fbf3ff;
		color: #bf2ff9;
	}
	.zzAdminItemJjI5 {
		background: #f2f7f3;
		color: #1d7b3a;
	}
}
.ausBox {
	height: 66px;
}
</style>
